/* eslint-disable no-console */
import { clearDealerLoookupFormData, initDealerLoookupForm, showDefaultState, showNoDealersState } from './dealer-availability/dealer-lookup-form';
import { clearEmailSignupFormData } from './dealer-availability/email-signup-form';
import { getItemsFromAccount } from './consumer-account/storage-actions';
import { getUserSignUpStatus } from './dealer-availability/email-signup-status';
import SiteModal from './site-modal';

// Check for cookie so that if a user has already signed-up to be notified, they don't continue to see the modal

const dealerAvailabilityModal = (options) => {
  const {
    state,
  } = options;
  const {
    isDealerAvailabilityModalActive,
    dealerAvailabilityModalDelay,
  } = window;
  const modalId = 'dealer-availability-modal';
  if (document.getElementById(modalId) === null) {
    return;
  }
  const modal = new SiteModal({
    id: 'dealer-availability-modal',
    callbacks: {
      onClose: () => {
        clearDealerLoookupFormData();
        clearEmailSignupFormData();
      },
    },
  });
  // if (isDealerAvailabilityModalActive) {
  switch (state) {
    case 'dealer-not-available':
      showNoDealersState();
      modal.open();
      break;
    case 'default':
      showDefaultState();
      break;
    default:
      showDefaultState();
  }
  // }
  // Check session storage to see if modal should be shown
  const lsDealerModal = 'vitale_dealermodal';
  const seenModal = window.sessionStorage.getItem(lsDealerModal);
  // console.log(`getUserSignUpStatus: ${getUserSignUpStatus()}`);
  // Do we need another state to show if user has already signed up for emails
  // ...not to show them the email sign-up again?
  // Already seen dealer availability modal, modal not active, or have already signed-up to be notified
  if (seenModal === 'yes' || !isDealerAvailabilityModalActive || getUserSignUpStatus()) {
    return;
  }

  const setSeenStatus = (status) => {
    window.sessionStorage.setItem(lsDealerModal, status);
  };

  const isSiteModalOpen = () => {
    const modals = document.querySelectorAll('.modal.modal-visible');
    return modals.length > 0;
  };

  const isSiteModalClosed = () => {
    const timer = setInterval(() => {
      if (!isSiteModalOpen()) {
        clearInterval(timer);
        setTimeout(() => {
          onModalDelayExpired(); /* eslint-disable-line no-use-before-define */
        }, dealerAvailabilityModalDelay);
      }
    }, 2000);
  };

  // Has user saved a dealer to their favorites
  const isSavedDealer = (callback) => {
    const { isAuthenticated } = window;
    if (isAuthenticated) {
      getItemsFromAccount('location', (data) => {
        const { dealer } = data;
        if (dealer === null) {
          callback();
        }
      });
    } else {
      callback();
    }
  };

  const onModalDelayExpired = () => {
    // Is there an active modal?
    if (isSiteModalOpen()) {
      // Set up timer to wait until no active modal
      isSiteModalClosed();
      return;
    }
    modal.open();
    setSeenStatus('yes');
  };

  // Also check if a user has dealer saved to account
  isSavedDealer(() => {
    setTimeout(() => {
      onModalDelayExpired();
    }, dealerAvailabilityModalDelay);
    initDealerLoookupForm();
  });
};

export default dealerAvailabilityModal;
/* eslint-enable no-console */
